<template>
  <section>
    <div class="container">
      <div class="card">
        <div v-if="!isUserLogged">
          <div class="center">
            <h1>Portail catalogue TecDoc</h1>
            <p>Veuillez vous connecter</p>
            <span class="space20"></span>
            <br/>
              <a  :href="login_url" class="button is-medium is-success">
                Connexion avec Google
              </a>
          </div>
        </div>
        <div v-else>
          <h1>Bonjour {{profile.name}}</h1>
                      <span class="space20"></span>

          <img class="profile" :src="profile.imageUrl">
          <button class="button is-medium is-info" @click="signout">
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
    
    <!-- <h1>Bienvenue {{profile.getGivenName()}}</h1> -->

  </section>
</template>

<script lang="js">
import Vue from "vue";
export default  {
  name: 'LoginPage',
  props: [],
  mounted() {
      // gapi.signin2.render('google-signin-btn', { // this is the button "id"
      // onsuccess: this.onSignIn // note, no "()" here
      // })

    if(sessionStorage.getItem("profile_token")){
      this.isUserLogged=true;
      
      return;
    }
    if(this.$route.query.code){
      var code = this.$route.query.code;
      this.axios.post(process.env.VUE_APP_API_URL+'auth',{
        "provider":"google",
        "code":code,
      })
      .then(response => {
        console.log(response);
        sessionStorage.setItem('profile_token',response.data.data);
        sessionStorage.setItem('email',response.data.extradata);
        this.$router.push('/search')
        location.reload();
        isUserLogged = true;
          // this.login_url = response.data.data.url;
      });
    }else{
      this.axios.get(process.env.VUE_APP_API_URL+'auth')
        .then(response => {
        this.login_url = response.data.data.url;
     });
    }
    
  },
  data() {
    return {
      showNav:false,
      login_url :"",
      isUserLogged: false,
      profile:{
        id:null,
        name:"",
        givenName:"",
        familyName:"",
        imageUrl:"",
        email:"",
      },
    }
  },
  methods: {
    signout(){
      sessionStorage.removeItem('profile_token');
      location.reload();
      this.isUserLogged = false;
    },
  },
  computed: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img.profile {
  border-radius: 50%;
}

h1 {
  font-size: 30px;
}
.card {
  padding: 50px 0;
}
.space20 {
  display: block;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPage.vue